//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent, toRefs, computed } from "@vue/composition-api";
import { useI18n } from "vue-i18n-composable";
export default defineComponent({
  name: "LenderSidebar",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    agentDetails: {
      type: Object,
      default: () => {}
    }
  },
  setup(props) {
    const {
      agentDetails
    } = toRefs(props);
    const {
      tc
    } = useI18n();
    const accountType = computed(() => {
      return tc(`global.doorr.${agentDetails.value.accountType}`, 1);
    });
    const customStyle = computed(() => {
      return "text-center text-regular-gray bold font-sm mt-1 mb-0 text-truncate";
    });
    return {
      accountType,
      customStyle
    };
  }
});